import { render, staticRenderFns } from "./imageShow.vue?vue&type=template&id=4d19d01b&scoped=true"
import script from "./imageShow.vue?vue&type=script&lang=js"
export * from "./imageShow.vue?vue&type=script&lang=js"
import style0 from "./imageShow.vue?vue&type=style&index=0&id=4d19d01b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d19d01b",
  null
  
)

export default component.exports